import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authStore } from '@/auth/authStore';

/**
 * Страховочный экран: обычно бэкенд-callback 303-ит сразу на `return`,
 * но если return указывал сюда — тихо доводим сессию и уходим на главную.
 */
export function AuthCallbackScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void authStore.bootstrap().then(() => {
      if (!cancelled) navigate('/', { replace: true });
    });
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <main data-testid="screen-auth-callback">
      <h1>Возврат после входа…</h1>
    </main>
  );
}
